import React, { Component } from "react";
const logoLatitud = <img src="/assets/images/brand/latitud.svg" alt="latitud" />
const logoPorto = <img src="/assets/images/brand/PortoHolding.svg" alt="Porto Holding" />
const logoEndeavor = <img src="/assets/images/brand/Endeavor.svg" alt="Endeavor" />
const logoJera = <img className="logoJera" src="/assets/images/brand/logoJera.svg" alt="Jera" />


class BrandTwo extends Component{
    render(){
        return(
            <React.Fragment>
                <ul className="brand-style-2">
                    <li className="col-lg-3 col-md-6 col-sm-6">
                   {logoPorto}
                    </li>
                    <li className="col-lg-3 col-md-6 col-sm-6">
                    {logoEndeavor}
                    </li>
                    <li className="col-lg-3 col-md-6 col-sm-6">
                    {logoLatitud}
                    </li>
                    <li className="col-lg-3 col-md-6 col-sm-6" style={{textAlign:'center'}}>
                    {logoJera}
                    </li>
                    
                </ul>
            </React.Fragment>
        )
    }
}
export default BrandTwo;